export const INSTRUCTIONS_HEADER_HEIGHT = 50;
export const BORDER_HEIGHT = 12;

export const PAGE_WIDTH_INCHES = 11;
export const PAGE_HEIGHT_INCHES = 8.5;

const PIXELS_PER_INCH = 96;

// The height of the page number footer in the bottom of the right side panel.
export const PAGE_NUMBER_FOOTER_HEIGHT = 20;

// The height of a <SectionHeader> component in the side panel (<PanelSection>).
const PANEL_SECTION_HEADER_HEIGHT = 32;

export const PANEL_HEIGHT =
  PAGE_HEIGHT_INCHES * PIXELS_PER_INCH -
  2 * BORDER_HEIGHT -
  PAGE_NUMBER_FOOTER_HEIGHT;

const PANEL_SECTION_PADDING = 12;
/**
 * The height of a panel without the top or bottom content/padding. This is
 * useful for determining how much content can fit in the panel.
 */
export const PANEL_INNER_HEIGHT =
  PANEL_HEIGHT - PANEL_SECTION_HEADER_HEIGHT - 2 * PANEL_SECTION_PADDING;

export const HIDDEN_LAYER_QUERY_PARAM = 'hl';
export const HIDDEN_SECTION_QUERY_PARAM = 'hs';
export const BASE_LAYER_QUERY_PARAM = 'bl';
export const BASE_LAYER_ROADS_QUERY_PARAM = 'blr';
export const BASE_LAYER_CONTOURS_QUERY_PARAM = 'blc';
export const BASE_LAYER_DARK_QUERY_PARAM = 'bld';
